import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import { Spinner } from '../index.js';

export default class TargetCapacityHistoryModal extends Component {
  formatNumber(value) {
    if (value === undefined || value === null || value === '') return '–';
    const num = Number(value);
    if (isNaN(num)) return value;
    return num.toLocaleString('en-US');
  }

  render() {
    const {
      isOpen,
      onClose,
      logs,
      rowData,
      loading,
      isQuarterView
    } = this.props;

    const factoryCode = rowData ? rowData.factoryCode : '';
    const capacityTypeCode = rowData ? rowData.capacityTypeCode : '';
    const weekStartDate = rowData ? rowData.weekStartDate : '';
    const headerDate = weekStartDate
      ? moment(weekStartDate).format('DD MMM YYYY')
      : '';

    const valueField = isQuarterView ? 'totalValue' : 'value';

    const displayLogs = isQuarterView
      ? logs
      : [...logs].sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0));

    const initialValue =
      displayLogs.length > 0
        ? this.formatNumber(displayLogs[0][valueField])
        : 'N/A';

    return (
      <Modal
        isOpen={isOpen}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          },
          content: {
            position: 'relative',
            inset: 'auto',
            width: '600px',
            maxWidth: '90vw',
            maxHeight: '80vh',
            overflow: 'auto',
            borderRadius: '6px',
            padding: 0,
            border: '1px solid #ccc',
            background: '#fff',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
          }
        }}
      >
        <button
          className="modal-close-btn ncss-btn-icon"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'none',
            border: 'none',
            fontSize: 18,
            cursor: 'pointer',
            color: '#333'
          }}
        >
          <i className="fas fa-times" />
        </button>

        <div style={{ padding: '20px 24px' }}>
          <div
            style={{
              borderBottom: '2px solid #0072ce',
              paddingBottom: 12,
              marginBottom: 16
            }}
          >
            <h5
              style={{
                margin: 0,
                fontSize: 15,
                fontWeight: 700,
                color: '#111'
              }}
            >
              Adjd Target Capacity Changes History — {factoryCode} /{' '}
              {capacityTypeCode}
              {headerDate ? ` / ${headerDate}` : ''}
              {isQuarterView ? ' (Quarterly)' : ''}
            </h5>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <Spinner large />
            </div>
          ) : (
            <div>
              {displayLogs.length > 0 ? (
                <div>
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      fontSize: 13
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: '#f5f5f5',
                          borderBottom: '2px solid #ddd'
                        }}
                      >
                        <th style={thStyle}>Date Changed</th>
                        <th style={thStyle}>Changed By</th>
                        <th style={thStyle}>Previous Value</th>
                        <th style={thStyle}>New Value</th>
                        <th style={thStyle}>Reason</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayLogs.map((log, idx) => {
                        const prevValue =
                          idx === 0
                            ? '–'
                            : this.formatNumber(
                                displayLogs[idx - 1][valueField]
                              );
                        return (
                          <tr
                            key={`tc-log-${log.timestamp}-${idx}`}
                            style={{
                              borderBottom: '1px solid #eee',
                              backgroundColor:
                                idx % 2 === 0 ? '#fff' : '#fafafa'
                            }}
                          >
                            <td style={tdStyle}>
                              {log.timestamp
                                ? moment(log.timestamp).format('DD MMM YYYY')
                                : ''}
                            </td>
                            <td style={tdStyle}>{log.user || ''}</td>
                            <td style={tdStyle}>{prevValue}</td>
                            <td style={tdStyle}>
                              {this.formatNumber(log[valueField])}
                            </td>
                            <td style={tdStyle}>{log.reason || ''}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  <div
                    style={{
                      marginTop: 16,
                      padding: '10px 12px',
                      backgroundColor: '#f0f7ff',
                      borderLeft: '3px solid #0072ce',
                      fontSize: 12,
                      color: '#555'
                    }}
                  >
                    <i className="fas fa-lock" style={{ marginRight: 6 }} />
                    Initial value ({initialValue}) is locked and cannot be
                    edited from this panel.
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '40px 0',
                    color: '#999'
                  }}
                >
                  <h5>No Adjd Target Capacity change history available.</h5>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

const thStyle = {
  textAlign: 'left',
  padding: '8px 10px',
  fontWeight: 600,
  color: '#333',
  fontSize: 12,
  whiteSpace: 'nowrap'
};

const tdStyle = {
  padding: '8px 10px',
  color: '#444'
};

TargetCapacityHistoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  logs: PropTypes.array,
  rowData: PropTypes.object,
  loading: PropTypes.bool,
  isQuarterView: PropTypes.bool
};

TargetCapacityHistoryModal.defaultProps = {
  logs: [],
  rowData: {},
  loading: false,
  isQuarterView: false
};
